import React, { useEffect } from 'react';

const PickerModal = ({ 
  showPicker, 
  pickerSearch, 
  setPickerSearch, 
  getFilteredOptions, 
  getSelectedIndexInFiltered, 
  pickerValue,
  selectPickerValue,
  closePicker 
}) => {
  // Закрытие окна выбора по Escape
  useEffect(() => {
    if (!showPicker) return;
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        closePicker();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [showPicker, closePicker]);

  if (!showPicker) return null;

  return (
    <div className="picker-overlay" onClick={closePicker}>
      <div className="picker-modal" onClick={(e) => e.stopPropagation()}>
        <div className="picker-header">
          <h3>Выберите значение</h3>
          <button className="picker-close" onClick={closePicker}>×</button>
        </div>
        
        <div className="picker-search">
          <input
            type="text"
            value={pickerSearch}
            onChange={(e) => setPickerSearch(e.target.value)}
            placeholder="Поиск..."
            className="form-control"
            autoFocus
          />
        </div>
        
        <div className="picker-content">
          <ul className="picker-list">
            {getFilteredOptions().map((option, index) => (
              <li
                key={option.value}
                className={`picker-item ${index === getSelectedIndexInFiltered() ? 'selected' : ''}`}
                onClick={() => selectPickerValue(option.value)}
              >
                <div className="picker-item-label">{option.label}</div>
                {option.description && (
                  <div className="picker-item-description">{option.description}</div>
                )}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default PickerModal;

